import URL from '../Url';
import {
  SAVED_CARD_FETCH_REQUEST,
  SAVED_CARD_FETCH_SUCCESS,
  SAVED_CARD_FETCH_FAIL,
  SAVED_CARD_DELETE_REQUEST,
  SAVED_CARD_DELETE_SUCCESS,
  SAVED_CARD_DELETE_FAIL,
  SAVED_CARD_CLEAR,
} from '../Constants/savedCardConstants.js';

// Fetch the logged-in user's saved card
export const fetchSavedCard = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SAVED_CARD_FETCH_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/saved-card`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to fetch saved card");

    dispatch({ type: SAVED_CARD_FETCH_SUCCESS, payload: data.savedCard });
  } catch (error) {
    dispatch({ type: SAVED_CARD_FETCH_FAIL, payload: error.message });
  }
};

// Remove the saved card
export const deleteSavedCard = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SAVED_CARD_DELETE_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/saved-card`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to delete saved card");

    dispatch({ type: SAVED_CARD_DELETE_SUCCESS });
    dispatch({ type: SAVED_CARD_CLEAR });
  } catch (error) {
    dispatch({ type: SAVED_CARD_DELETE_FAIL, payload: error.message });
  }
};